import { gql } from '@apollo/client'

export default gql(`
    query listUsers($search: String $project: String $status: USER_STATUS, $accessRoleGroups: [ID] $enabled: Boolean  ){
        listUsers(input:{
          id: $search
          status: $status
          accessRoleGroups: $accessRoleGroups
          enabled: $enabled
        }, project: $project){
          items{
            id
            status
            name
            enabled
            status
            lastLogin
            ip
            accessRoleGroups {
              id
              name
              modules{
                name
                permissions
              }
            }
          }
        }
    }`
)
